// 네이버 증권 시세 페이지 새 탭 오픈 (계좌 현금성자산 티커는 무시)

// 확정된 네이버 증권 URL을 한 곳에 모아둔다. 아래 handle*Click 함수들은 전부 이 객체를 참조한다.
const NAVER_URLS = {
  // 국내종목 시세 페이지 (ticker: 종목코드, 예: 005930)
  domesticStock: (ticker) => `https://stock.naver.com/domestic/stock/${ticker}/price`,
  // 해외종목(ETF 등) 시세 페이지 (code: 티커 또는 "티커.거래소접미사")
  worldStockEtf: (code) => `https://stock.naver.com/worldstock/etf/${code}/price`,
  // 해외종목 거래소 접미사 (네이버 증권 worldstock 코드 기준).
  // 이 프로젝트는 종목별 거래소를 별도로 저장하지 않아 자주 쓰는 종목 위주로 매핑해두고,
  // 매핑에 없는 티커는 개별 종목 상장이 가장 많은 NASDAQ(O)을 기본값으로 사용한다.
  // 값이 빈 문자열('')이면 접미사 없이 티커만 사용 (예: SPY).
  // ⚠ 이 표에 없는 티커의 거래소가 실제와 다르면 잘못된 페이지로 연결될 수 있으니,
  //    사용 중 오류를 발견하면 이 목록에 추가해서 보완할 것.
  usExchangeSuffix: {
    SPY: '',                 // 접미사 없음
    QQQ: 'O', QQQM: 'O',
    SCHD: 'K',
    VOO: 'P', IVV: 'P', VTI: 'P', DIA: 'P', IWM: 'P',
    VEA: 'P', VWO: 'P', GLD: 'P', SLV: 'P', TLT: 'P', AGG: 'P', BND: 'P',
    KO: 'N', JPM: 'N', V: 'N', JNJ: 'N', DIS: 'N', BRK: 'N',
  },
  kospi:        'https://stock.naver.com/domestic/index/KOSPI/price',
  kosdaq:       'https://stock.naver.com/domestic/index/KOSDAQ/price',
  sp500:        'https://stock.naver.com/worldstock/index/.INX/price',
  nasdaq100:    'https://stock.naver.com/worldstock/index/.NDX/price',
  exchangeRate: 'https://stock.naver.com/marketindex/exchange/FX_USDKRW/price',
  gold:         'https://stock.naver.com/marketindex/metals/GCcv1/price',
};

// 국내 종목코드는 숫자로만 구성 (예: 005930). 그 외(알파벳 포함)는 해외종목으로 간주.
const isDomesticTicker = (ticker) => /^\d+$/.test(ticker);

// NAVER_URLS.usExchangeSuffix['SPY']는 빈 문자열이라 falsy이므로 || 대신 ?? 사용
// (|| 였다면 SPY도 매핑이 없는 것처럼 처리되어 기본값 'O'가 잘못 붙었을 것)
const getUsExchangeSuffix = (ticker) => NAVER_URLS.usExchangeSuffix[ticker.toUpperCase()] ?? 'O';

// marketType: 'KR' | 'US' | undefined/null
// tb_stock_master.market_code_id를 넘겨받으면 그 값으로 국내/해외를 판단하고,
// 값이 없는 호출부(아직 market_type을 안 내려주는 화면)에서는 기존 숫자 패턴
// 추측(isDomesticTicker)을 폴백으로 사용한다.
export const handleTickerClick = (ticker, marketType) => {
  if (!ticker || ticker === '현금잔액') return;
  const isDomestic = marketType != null ? marketType === 'KR' : isDomesticTicker(ticker);
  if (isDomestic) {
    window.open(NAVER_URLS.domesticStock(ticker), '_blank');
    return;
  }
  const t      = ticker.toUpperCase();
  const suffix = getUsExchangeSuffix(t);
  const code   = suffix ? `${t}.${suffix}` : t;
  window.open(NAVER_URLS.worldStockEtf(code), '_blank');
};

// 네이버 증권 코스피 지수 상세 페이지
export const handleKospiClick = () => {
  window.open(NAVER_URLS.kospi, '_blank');
};

// 네이버 증권 코스닥 지수 상세 페이지
export const handleKosdaqClick = () => {
  window.open(NAVER_URLS.kosdaq, '_blank');
};

// 네이버 증권 S&P500 지수 상세 페이지
export const handleSp500Click = () => {
  window.open(NAVER_URLS.sp500, '_blank');
};

// 네이버 증권 나스닥100 지수 상세 페이지
export const handleNasdaq100Click = () => {
  window.open(NAVER_URLS.nasdaq100, '_blank');
};

// 네이버 증권 원달러 환율 상세 페이지
export const handleExchangeRateClick = () => {
  window.open(NAVER_URLS.exchangeRate, '_blank');
};

// 네이버 증권 국제 금 시세 상세 페이지
export const handleGoldClick = () => {
  window.open(NAVER_URLS.gold, '_blank');
};
